import { Errors } from '@/containers/Errors/Errors'
import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { ErrorHandlingSagaPreset, type ErrorHandlingSagaPagedQuery } from '@/dtos/ErrorHandlingSaga'
import { useGetErrors } from '@/hooks/useErrorHandlingSagas'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { type IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { createContext, useContext, useEffect, useState } from 'react'


export const errorsFilterContext = createContext<IPaginationContext<ErrorHandlingSagaPagedQuery>>(
  {} as IPaginationContext<ErrorHandlingSagaPagedQuery>
)

export const ErrorsPage = () => {
  const { data: gridData, mutateAsync: getErrorsAsync, isPending } = useGetErrors()

  const errors = gridData?.items || []
  const totalCount = gridData?.totalCount || 0

  const [filter, setFilter] = useState<ErrorHandlingSagaPagedQuery>({
    pageIndex: 1,
    pageSize: 20,
    preset: ErrorHandlingSagaPreset.Unassigned,   // §6.2 default — "Nepřiřazené chyby"
  })

  useEffect(() => {
    getErrorsAsync(filter)
  }, [filter])

  const reload = () => getErrorsAsync(filter)

  return (
    <PageWrapper
      header={
        <>
          <DashboardHeader title="Přehled chyb" />
        </>
      }
      mainProps={{ sx: { pt: { base: 0, md: 8 }, gap: 6, display: 'grid' } }}
    >
      <errorsFilterContext.Provider
        value={{
          loading: isPending,
          totalCount,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? 20,
          filter,
          setCurrentPage: (p) => setFilter(f => ({ ...f, pageIndex: p })),
          setPageSize: (s) => setFilter(f => ({ ...f, pageSize: s })),
          updateFilter: setFilter,
          reload,
        }}
      >
        <Errors errors={errors} />
      </errorsFilterContext.Provider>
    </PageWrapper>
  )
}

export const useErrorsFilterContext = () => {
  const context = useContext(errorsFilterContext)

  if (!context || context === undefined) {
    throw new Error('useErrorsFilterContext must be used within an ErrorsPage')
  }

  return context
}
